module.exports = "<sx-listado-templates \r\n  [capturarClickItem]=\"'true'\"\r\n  (itemClicked)=\"asociarAChannel($event)\">\r\n</sx-listado-templates>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/alias/select.template.component.html
// module id = ../../../../../src/app/private/channels/alias/select.template.component.html
// module chunks = main